import { render, staticRenderFns } from "./SelectRiskLocation.vue?vue&type=template&id=67a35084&"
import script from "./SelectRiskLocation.vue?vue&type=script&lang=js&"
export * from "./SelectRiskLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports